import { render } from "./BlogContent.vue?vue&type=template&id=3b89da71&scoped=true&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import "./BlogContent.vue?vue&type=style&index=0&id=3b89da71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b89da71"]])

export default __exports__